import "./BasicInfoSection.css";

function BasicInfoSection({
  formData,
  updateField,
}) {
  return (
    <div className="food-form-section">

      <h3 className="section-title">
        Basic Information
      </h3>

      <div className="basic-info-grid">

        {/* Food Name */}

        <div className="form-group">

          <label>
            Food Name *
          </label>

          <input
            type="text"
            placeholder="Enter food name"
            value={formData.foodName}
            onChange={(e) =>
              updateField("foodName", e.target.value)
            }
            maxLength={100}
          />

          <small>
            {formData.foodName.length}/100
          </small>

        </div>

        {/* Short Description */}

        <div className="form-group full-width">

          <label>
            Short Description
          </label>

          <textarea
            rows={3}
            placeholder="Short description shown to customers..."
            value={formData.description}
            onChange={(e) =>
              updateField(
                "description",
                e.target.value
              )
            }
            maxLength={250}
          />

          <small>
            {formData.description.length}/250
          </small>

        </div>

      </div>

    </div>
  );
}

export default BasicInfoSection;